module.exports = __webpack_public_path__ + "1d2ba7a7de24a905ba61bef85d0ee938.png";